import { render, staticRenderFns } from "./SfPrice.vue?vue&type=template&id=a8ec5104&functional=true"
import script from "./SfPrice.vue?vue&type=script&lang=js"
export * from "./SfPrice.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfPrice.vue?vue&type=style&index=0&id=a8ec5104&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "37a9a7b5"
  
)

export default component.exports